import React, {Fragment} from 'react';
import { BaseColumn } from '../../../components/shared/sharedStyles.styles';
import FilterField from './FilterField';
import DateSearchField from './DateSearchFieldBaixarCobranca';
import {FilterIcon, FilterButton, FilterText} from './SearchStyles'
import filter from '../../../img/svg/ico-filter.svg';

const SearchGroupBaixarCobranca = ({setFilter, endDate, startDate, filterDate, hiddenInputFilter, changeSelectFilter, resetSelectFilter, selectedOption, showSelectFilter}) => {
    const onFormSubmit = e => {
      e.preventDefault()
      filterDate()
    }

    const resetSelected = () => {

    }

    const placeholder = selectedOption === 'cobranca_id' ? 'Filtrar ID de Cobrança' : selectedOption === 'solicitacao_id' ? 'Filtrar ID Solicitação' : "Filtrar ID de Cobrança"

    return (
        <BaseColumn xs="12" sm="12" md="8" lg="10" xl="10" style={{paddingBottom: '.4em'}}>
          <form onSubmit={onFormSubmit} style={{width: '100%', display: 'flex'}}>
            {showSelectFilter &&
              <div style={{display: "inline-block", paddingRight: 30}} >
                  <FilterIcon src={filter} />
                  <select onChange={changeSelectFilter} value={selectedOption} style={{width: 134, borderBottomColor: '#cdcdcd', borderTop: 'none', borderLeft: 'none', borderRight: 'none', outlineWidth: 0, color: '#7f7f7f', marginTop: 1}}>
                    {/* <option value="" disabled selected={true}>Filtrar por tudo</option> */}
                    <option value="cobranca_id" selected={true}>ID de Cobrança</option>
										<option value="solicitacao_id" selected={true}>ID Solicitação</option>
                  </select>
                  {/* {selectedOption &&
                    <div style={{display: 'inline-block', cursor: 'pointer', marginLeft: 14, color: '#7f7f7f', fontWeight: 700}} onClick={resetSelectFilter}>
                      x
                    </div>
                  } */}
              </div>
            }

            {!hiddenInputFilter &&
              <div style={{display: "inline-block", paddingRight: 30}} >
                  <FilterIcon src={filter} />
                  <FilterField
                      type="text"
                      placeholder={placeholder}
                      submitSearch={setFilter}
                      noIcon={true}
                  />
              </div>
            }
            
            <div style={{display: "inline-block", marginLeft: 20}}>
                <FilterIcon src={filter} style={{marginRight: "5px"}} />
                <FilterText><FilterText style={{fontWeight: 600, fontSize: "13px"}}>Período: </FilterText> de </FilterText>
                <DateSearchField
                    type="text"
                    placeholder="mm/aaaa"
                    submitSearch={startDate}
                />
                <FilterText> a </FilterText>
                <DateSearchField
                    type="text"
                    placeholder="mm/aaaa"
                    submitSearch={endDate}
                />
                <FilterButton onClick={filterDate} >
                    Filtrar
                </FilterButton>
            </div>
          </form>
        </BaseColumn>
    )
}

export default SearchGroupBaixarCobranca